import { Theme } from "@mui/material/styles";

/**
 * Enum per i nomi dei temi disponibili
 */
export enum ThemeNames {
    PRODUCTION = "production",
    TEST = "test",
    DEVELOPMENT = "development",
    NATURE = "nature",
    EVEREST = "everest",
    SYSTEL = "systel",
}

/**
 * Tipo per la mappa dei temi
 */
export type ThemeMap = Record<string, Theme>;